import type { TransferPermission } from '../../../project_starburst';

const rolesOf = (jsonValue: unknown): ReadonlyArray<Record<string, unknown>> => {
  const rows = (jsonValue as { availableRoles?: unknown } | null)?.availableRoles;
  return Array.isArray(rows) ? (rows as Record<string, unknown>[]) : [];
};

export function mergedJsonValue(response: unknown): Record<string, unknown> {
  if (!Array.isArray(response) || response.length === 0) return {};
  const values = (response[0] as { values?: unknown })?.values;
  if (!Array.isArray(values)) return {};
  const merged = values.find((v) => (v as { value?: unknown })?.value === 'MERGED') as { jsonValue?: unknown } | undefined;
  return merged?.jsonValue != null && typeof merged.jsonValue === 'object' ? (merged.jsonValue as Record<string, unknown>) : {};
}

export function canExcludeFromConfig(roles: readonly string[], jsonValue: unknown): boolean {
  const available = rolesOf(jsonValue);
  return roles.some((role) => available.find((r) => r.role_name === role)?.showExcludeCase === true);
}

export function transferPermissionFromConfig(roles: readonly string[], jsonValue: unknown): TransferPermission {
  const available = rolesOf(jsonValue);
  return roles.some((role) => available.find((r) => r.role_name === role)?.transferCase === true) ? 'allowed' : 'denied';
}
